import React from 'react';
import { Section as SectionDI } from '@atlaskit/side-navigation';
import { useIntlV2 as useIntlDI } from '@atlassian/jira-intl/src/v2/use-intl.tsx';
import { MenuItem as MenuItemDI } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { matchUrlPathname as matchUrlPathnameDI } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/index.tsx';
import { createReportUrl } from '../../../utils/index.tsx';
import messages from '../messages.tsx';
import type { ReportActionsProps } from './types.tsx';

export const ReportActions = ({
	MenuItem = MenuItemDI,
	Section = SectionDI,
	features,
	matchUrlPathname = matchUrlPathnameDI,
	projectKey,
	useIntl = useIntlDI,
}: ReportActionsProps) => {
	const { formatMessage } = useIntl();
	const { hasManageReport, hasNewReport } = features;
	return (
		<Section>
			{hasNewReport && (
				<MenuItem
					analytics={{ itemId: 'custom-new' }}
					href={createReportUrl(projectKey, '/custom/new')}
					selectedOn={matchUrlPathname()}
				>
					{formatMessage(messages.newReport)}
				</MenuItem>
			)}
			{hasManageReport && (
				<MenuItem
					analytics={{ itemId: 'custom-manage' }}
					href={createReportUrl(projectKey, '/custom/manage')}
					selectedOn={matchUrlPathname()}
				>
					{formatMessage(messages.manageReports)}
				</MenuItem>
			)}
		</Section>
	);
};
